var map = {
	"./de/btn-back.png": "ndrf",
	"./en/btn-back.png": "xIjX",
	"./es/btn-back.png": "haHT",
	"./fr/btn-back.png": "V4Ye",
	"./ja/btn-back.png": "4drW",
	"./ko/btn-back.png": "Q/qS",
	"./pt/btn-back.png": "BR3F",
	"./ru/btn-back.png": "oT6m",
	"./th/btn-back.png": "sHy+",
	"./zh-Hant/btn-back.png": "H93Y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ObCc";